module.exports = __webpack_public_path__ + "static/media/tick.80b4e6cc.svg";